/** Categories of the disclosures */
const DISCLOSURE_CATEGORY_ICONS = {
  HIGHLIGHTS: 'GenericFeature',
  CONNECTED: 'Connected',
  RESTRICTIONS_LIMITATIONS: 'GenericDisclosures',
  SELLER_TRADER: 'SellerTrader',
};

/** Disclosure types */
const DISCLOSURE_TYPES = {
  TICKET_FEATURE: 'Ticket Feature',
  PACKAGES_AND_EXCLUSIVES: 'Packages and Exclusives',
  CONNECTED: 'Connected',
  LISTING_RESTRICTIONS: 'Listing Restrictions',
  LISTING_DISCLOSURE: 'Listing Disclosure',
  SELLER_COMMENTS: 'Seller Comments',
  SELLER_TRADER: 'SellerTrader',
};

/** Mapping between disclosure type and category icon */
const DISCLOSURE_TYPE_ICON_MAPPING = {
  [DISCLOSURE_TYPES.TICKET_FEATURE]: DISCLOSURE_CATEGORY_ICONS.HIGHLIGHTS,
  [DISCLOSURE_TYPES.PACKAGES_AND_EXCLUSIVES]: DISCLOSURE_CATEGORY_ICONS.HIGHLIGHTS,
  [DISCLOSURE_TYPES.CONNECTED]: DISCLOSURE_CATEGORY_ICONS.CONNECTED,
  [DISCLOSURE_TYPES.LISTING_RESTRICTIONS]: DISCLOSURE_CATEGORY_ICONS.RESTRICTIONS_LIMITATIONS,
  [DISCLOSURE_TYPES.LISTING_DISCLOSURE]: DISCLOSURE_CATEGORY_ICONS.RESTRICTIONS_LIMITATIONS,
  [DISCLOSURE_TYPES.SELLER_COMMENTS]: DISCLOSURE_CATEGORY_ICONS.RESTRICTIONS_LIMITATIONS,
  [DISCLOSURE_TYPES.SELLER_TRADER]: DISCLOSURE_CATEGORY_ICONS.SELLER_TRADER,
};

/** Enum of some known disclosures with their ID */
const DISCLOSURE_IDS = {
  AISLE_SEAT: 101,
  PARKING: 102,
  SELLER_TRADER: 103,
  OBSTRUCTED_LIMITED_VIEW: 201,
  WHEELCHAIR_ONLY: 202,
  POSSIBLE_OBSTRUCTION: 2001,
  REAR_STAGE_VIEW: 2361,
  ADA_WHEELCHAIR_ACCESIBLE_ONLY: 3006,
  LIMITED_SIDE_VIEW: 3248,
  SIDE_VIEW: 3288,
  NO_VIEW: 4369,
  RESTRICTED_VIEW: 4750,
  PARTIAL_VIEW: 5370,
  VISUALLY_IMPAIRED_ONLY: 5767,
  PRIMARY_PARTNER: 13372,
  RESTRICTED_VIEW2: 13734,
  WHEELCHAIR_AND_COMPANION: 14541,
  FOOD_AND_DRINK_VOUCHER_INCLUDED: 14612,
  FAN_CARD_REQUIRED: 15653,
  SELLER_IS_SHI_EMPLOYEE_OR_CONTRACTOR: 16481,
  SELLER_IS_SH_OR_SH_GROUP: 16482,
  SELLER_IS_ORGANISER: 16513,
  ADA_ACCESSIBLE: 16923,
  ON_THE_FIFTY: 19248,
  LEGENDS: 19249,
  LIVE_54: 19268,
  TOUCHDOWN_CLUB: 19269,
};

// We group traits so we can easily assign icons
const AISLE_DISCLOSURES = Object.freeze([DISCLOSURE_IDS.AISLE_SEAT]);
const PARKING_DISCLOSURES = Object.freeze([DISCLOSURE_IDS.PARKING]);
const OBSTRUCTED_VIEW_DISCLOSURES = Object.freeze([
  DISCLOSURE_IDS.OBSTRUCTED_LIMITED_VIEW,
  DISCLOSURE_IDS.PARTIAL_VIEW,
  DISCLOSURE_IDS.RESTRICTED_VIEW,
  DISCLOSURE_IDS.NO_VIEW,
  DISCLOSURE_IDS.POSSIBLE_OBSTRUCTION,
  DISCLOSURE_IDS.REAR_STAGE_VIEW,
  DISCLOSURE_IDS.LIMITED_SIDE_VIEW,
  DISCLOSURE_IDS.SIDE_VIEW,
  DISCLOSURE_IDS.RESTRICTED_VIEW2,
]);
const ACCESIBILITY_DISCLOSURES = Object.freeze([
  DISCLOSURE_IDS.WHEELCHAIR_ONLY,
  DISCLOSURE_IDS.ADA_ACCESSIBLE,
  DISCLOSURE_IDS.ADA_WHEELCHAIR_ACCESIBLE_ONLY,
  DISCLOSURE_IDS.WHEELCHAIR_AND_COMPANION,
  DISCLOSURE_IDS.VISUALLY_IMPAIRED_ONLY,
]);
const VIP_HOSPITALITY_DISCLOSURES = Object.freeze([
  DISCLOSURE_IDS.TOUCHDOWN_CLUB,
  DISCLOSURE_IDS.LIVE_54,
  DISCLOSURE_IDS.ON_THE_FIFTY,
  DISCLOSURE_IDS.LEGENDS,
]);
const FOOD_DISCLOSURES = Object.freeze([
  DISCLOSURE_IDS.FAN_CARD_REQUIRED,
  DISCLOSURE_IDS.FOOD_AND_DRINK_VOUCHER_INCLUDED,
]);
const SELLER_DISCLOSURES = Object.freeze([
  DISCLOSURE_IDS.SELLER_TRADER,
  DISCLOSURE_IDS.SELLER_IS_SHI_EMPLOYEE_OR_CONTRACTOR,
  DISCLOSURE_IDS.SELLER_IS_ORGANISER,
  DISCLOSURE_IDS.SELLER_IS_SH_OR_SH_GROUP,
]);
const PARTNER_DISCLOSURES = Object.freeze([DISCLOSURE_IDS.PRIMARY_PARTNER]);

/** Mapping of bamboo icon names */
const DISCLOSURE_ICON_NAMES = {
  AISLE_SEAT: 'AisleSeat',
  ACCESIBILITY: 'Accesibility',
  PRIMARY_PARTNER: 'PrimaryPartner',
  RESTAURANT: 'Restaurant',
  OBSTRUCTED_VIEW: 'ObstructedView',
  PARKING: 'ParkingPass',
  SELLER_TRADER: 'SellerTrader',
};

/**
 * Returns a map of each disclosure id with the corresponding icon value
 * @param {Array} disclosures array of disclosures
 * @param {string} icon icon name
 * @returns a map with disclosure id as key and icon as value
 */
const constructMapping = (disclosures, icon) => {
  return disclosures.reduce((mapping, disclosureId) => {
    mapping[disclosureId] = icon;

    return mapping;
  }, {});
};

/** Mapping of some disclosures to icons */
const DISCLOSURE_ID_ICON_MAPPING = {
  ...constructMapping(AISLE_DISCLOSURES, DISCLOSURE_ICON_NAMES.AISLE_SEAT),
  ...constructMapping(ACCESIBILITY_DISCLOSURES, DISCLOSURE_ICON_NAMES.ACCESIBILITY),
  ...constructMapping(PARTNER_DISCLOSURES, DISCLOSURE_ICON_NAMES.PRIMARY_PARTNER),
  ...constructMapping(OBSTRUCTED_VIEW_DISCLOSURES, DISCLOSURE_ICON_NAMES.OBSTRUCTED_VIEW),
  ...constructMapping(PARKING_DISCLOSURES, DISCLOSURE_ICON_NAMES.PARKING),
  ...constructMapping(SELLER_DISCLOSURES, DISCLOSURE_ICON_NAMES.SELLER_TRADER),
  ...constructMapping(VIP_HOSPITALITY_DISCLOSURES, DISCLOSURE_ICON_NAMES.RESTAURANT),
  ...constructMapping(FOOD_DISCLOSURES, DISCLOSURE_ICON_NAMES.RESTAURANT),
};

export {
  DISCLOSURE_IDS,
  DISCLOSURE_TYPES,
  DISCLOSURE_ID_ICON_MAPPING,
  DISCLOSURE_TYPE_ICON_MAPPING,
  DISCLOSURE_CATEGORY_ICONS,
  DISCLOSURE_ICON_NAMES,
};
